import script from "./ListarPlanosContas.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarPlanosContas.vue?vue&type=script&setup=true&lang=js"

import "./ListarPlanosContas.vue?vue&type=style&index=0&id=24f37cf9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24f37cf9"]])

export default __exports__